import React, { useContext } from 'react';
import { PopoverPosition } from '@blueprintjs/core';
import { Button, Flex, Icon, Menu, MenuItem, Popover } from 'core/components';
import BoardPanelTypes from 'app/stores/boards/boardPanelTypes';
import { MobXProviderContext } from 'mobx-react';

function useAllowedPanelTypes(excludeTypes = []) {
  const { $auth } = useContext(MobXProviderContext);
  const permissionExcludes = !$auth.hasPermission('ude', { overrideForSudo: false }) ? ['ude', 'savedView'] : [];
  const excludes = [...excludeTypes, ...permissionExcludes];
  return Object.keys(BoardPanelTypes).filter((type) => !excludes.includes(type));
}

function AddPanelMenu({ excludes = [], onAddPanel, ...rest }) {
  const types = useAllowedPanelTypes(excludes);
  return (
    <Menu {...rest}>
      {types.map((type) => {
        const { title, icon } = BoardPanelTypes[type];
        return (
          <MenuItem
            multiline
            key={type}
            icon={<Icon icon={icon} iconSize={22} />}
            text={<Flex flexDirection="column">{title}</Flex>}
            onClick={() => onAddPanel(type)}
          />
        );
      })}
    </Menu>
  );
}

export function AddPanelButton({ board, onAddPanel, text = 'Add', panelTypeBlacklist = [], ...rest }) {
  return (
    <Popover
      position={PopoverPosition.BOTTOM_RIGHT}
      modifiers={{
        flip: { enabled: true },
        keepTogether: { enabled: true },
        preventOverflow: { enabled: true, boundariesElement: 'window' },
        offset: { enabled: true, offset: '0,2px' }
      }}
    >
      <Button rightIcon="caret-down" text={text} data-testid="AddPanelButton" {...rest} />
      <AddPanelMenu excludes={panelTypeBlacklist} onAddPanel={onAddPanel} />
    </Popover>
  );
}

export function AddPanelMenuItem({ board, onAddPanel, panelTypeBlacklist, ...rest }) {
  return (
    <MenuItem text="Add Panel" {...rest}>
      <AddPanelMenu excludes={panelTypeBlacklist} onAddPanel={onAddPanel} />
    </MenuItem>
  );
}
